export const adminFr = {
    title: 'Administration',
    filter: {
        organization: 'Organisation',
        allOrganizations: 'Toutes les organisations'
    },
    orders: {
        title: 'Commandes',
        list: 'Liste des commandes — toutes organisations'
    },
    templates: {
        title: "Gabarits d'impression",
        list: "Liste des gabarits d'impression — toutes organisations"
    },
    customers: {
        title: 'Clients',
        list: 'Liste des clients — toutes organisations'
    },
    products: {
        title: 'Produits',
        list: 'Liste des produits — toutes organisations'
    }
}
